<template src="../../templates/instrumentPage/my-offers.html"></template>

<script>
export default {
    props: {
        data: {
            type: String,
            default: ''
        }
    }
};
</script>
